import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions();

export async function manageDomain(payload) {
  const callable = getFunctions().httpsCallable("manageDomain");
  const result = await callable(payload);
  return result.data;
}

export async function assignFdeRole(payload) {
  const callable = getFunctions().httpsCallable("assignFdeRole");
  const result = await callable(payload);
  return result.data;
}

export async function revokeFdeRole(payload) {
  const callable = getFunctions().httpsCallable("revokeFdeRole");
  const result = await callable(payload);
  return result.data;
}

export async function createInstitutionalTci(payload) {
  const callable = getFunctions().httpsCallable("createInstitutionalTci");
  const result = await callable(payload);
  return result.data;
}

export async function requestTciSharing(payload) {
  const callable = getFunctions().httpsCallable("requestTciSharing");
  const result = await callable(payload);
  return result.data;
}

export async function reviewTciSharingRequest(payload) {
  const callable = getFunctions().httpsCallable("reviewTciSharingRequest");
  const result = await callable(payload);
  return result.data;
}

export async function manageGlobalTci(payload) {
  const callable = getFunctions().httpsCallable("manageGlobalTci");
  const result = await callable(payload);
  return result.data;
}

export async function submitCmrDataFlowRequest(payload) {
  const callable = getFunctions().httpsCallable("submitCmrDataFlowRequest");
  const result = await callable(payload);
  return result.data;
}

export async function reviewCmrDataFlowRequest(payload) {
  const callable = getFunctions().httpsCallable("reviewCmrDataFlowRequest");
  const result = await callable(payload);
  return result.data;
}
